import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import _ from 'lodash';
import classnames from 'classnames/bind';
import {
  IBreadCrumb,
  ICountry,
  IModal,
  IOilFilter,
  IProd,
  IState,
  IVehicle,
  ProductCategory,
  Replacement,
} from '../../interface';
import style from './index.module.scss';
import Breadcrumb from '../Breadcrumb';
import Header from '../Header';
import publicImage from '../../utils/publicImage';
import Information from './Information';
import Loading from '../Loading';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import actions from '../../redux/actions';
import Modal from '../Modal';
import { ModalHref } from '../../interface/emnu';
import { FindTheRightOil } from 'castrol-oil-search';
import VehicleSelection from '../WhereToBuy/VehicleSelection';
import { getProduct } from '../../services';
import { isOnlyWTBcountry } from '../../utils/isOnlyWTBcountry';
import { useAppName } from '../../hooks/use-app-names';
import { APPNAME, FASTSCAN } from '../../constants';

const cx = classnames.bind(style);

interface IProps extends IOilFilter {
  modal: IModal;
  replacements: Replacement;
  setModal: (value: IModal) => void;
  setVehicle: (value: IVehicle | undefined) => void;
  productCategoriesList: ProductCategory[] | null;
  country: ICountry;
}

export const ProductInformation = (props: IProps) => {
  const {
    modal,
    replacements,
    setModal,
    setVehicle,
    productCategoriesList,
    country: currentCountry,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const i18n = localStorage.getItem('languageCode') as string;
  const country = (localStorage.getItem('countryCode') ||
    process.env.REACT_APP_COUNTRYCODE) as string;
  const navigation = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const productId = searchParams.get('id');
  const [product, setProduct] = useState<IProd>();
  const [isMount, setIsMount] = useState<boolean>(false);
  const breadcrumb: IBreadCrumb[] = [
    {
      value: 'Castrol',
      href: '#',
      static: true,
    },
    {
      value: 'Oil Selector',
      href: '#',
      static: true,
    },
    {
      value: 'Recommended oils',
      href: '#',
      static: true,
    },
    {
      value: product?.name ? product?.name : '',
    },
  ];

  useEffect(() => {
    !productId && navigation('/');
    setIsMount(true);
    const controller = new AbortController();
    let isMounted = true;
    const isWorkshopOwner = _.isEqual(
      sessionStorage.getItem('selectedType'),
      'true',
    )
      ? true
      : false;
    _.isNumber(_.toNumber(productId)) &&
      getProduct(_.toNumber(productId), isWorkshopOwner).then((d) => {
        if (isMounted) {
          setProduct(d.data);
          setIsMount(false);
        }
      });
    return () => {
      controller.abort();
      isMounted = false;
    };
  }, []);

  const selectVehicleHandle = (value: string | number) => {
    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({ visibie: false, href: 0 });
  };
  const selectProductHandle = (value: string | number) => {
    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({ visibie: false, href: 0 });
    location.reload()
  };

  const onWTBClick = () => {
    searchParams.set('page', 'wheretobuy');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({ visibie: false, href: 0 });
  };

  const onBack = useCallback(() => {
    searchParams.delete('page');
    searchParams.delete('id');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    isFastScan && searchParams.set('SearchState', 'Preserved');
    setSearchParams(searchParams);
  }, []);

  return (
    <>
      <div className={`page ${cx('page')}`}>
        <Header />
        <div className={cx('container')}>
          {/* Banner section */}
          <div className={cx('banner')}>
            <img src={publicImage('hero-image.jpg')} />
          </div>
          {/* Breadcrumb and titie above banner */}
          <div className={cx('heading')}>
            {isFastScan && (
              <span role='link'
                onClick={onBack}
                dangerouslySetInnerHTML={{__html: '< Back'}}
                className='white-link'
              ></span>
            )}
            <Breadcrumb dataList={breadcrumb} />
            <h2>{product?.name}</h2>
          </div>
          {/* Main container */}
          {!isMount ? (
            <div className={cx('main-content')}>
              {/* filter section */}

              <div className={cx('filter-secion')}>
                <div
                  className={cx('vehicle')}
                  onClick={() =>
                    setModal({ visibie: true, href: ModalHref.FindTheRightOil })
                  }
                >
                  <VehicleSelection
                    setVehicle={setVehicle}
                    disabled={isOnlyWTBcountry(currentCountry.isoCode)}
                  />
                </div>
              </div>
              {product && (
                <div className={cx('information')}>
                  <Information
                    replacements={replacements}
                    dataList={product}
                    productCategories={
                      productCategoriesList ? productCategoriesList : []
                    }
                  />
                </div>
              )}
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      {_.isEqual(modal.href, ModalHref.FindTheRightOil) && modal.visibie && (
        <Modal className={cx('abs-modal', 'abs-find-modal')}>
          <FindTheRightOil
            country={country}
            onVehicleSelect={(value) => selectVehicleHandle(value)}
            onProductSelect={(value) => selectProductHandle(value)}
            onWTBClick={onWTBClick}
            i18n={i18n}
            locales={replacements}
            baseAPI={process.env.REACT_APP_PROVIDER_URL}
            restore={isFastScan}
          />
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  modal: state.modal,
  replacements: state.replacements,
  productCategoriesList: state.productCategoriesList,
  country: state.country,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
  setVehicle: (vehicle: IVehicle | undefined) =>
    dispatch(actions.setVehicle(vehicle)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductInformation);
